import AdminFooter from "./components/AdminFooter";
import App from "./components/App";

export { App as Footer, AdminFooter };
